'use strict';

var angular = require('angular');
var _ = require('lodash');
var Sly = require('@sabre/sabre-avro-sly');
var CarouselDirective = function CarouselDirective($window, $timeout) {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    scope: {
      isCollapsible: '=?',
      isVisible: '=?',
      collapsibleIconUpName: '@?',
      collapsibleIconDownName: '@?'
    },
    template: require('../templates/carousel.html'),
    link: function link(scope, element, attrs) {
      if (typeof scope.isVisible === 'undefined') {
        scope.isVisible = true;
      }
      element.on('mousedown', function () {
        var chart = element.find('.rm-chart');
        if (chart) {
          chart.css('pointer-events', 'none');
        }
      });
      element.on('mouseup', function () {
        var chart = element.find('.rm-chart');
        if (chart) {
          chart.css('pointer-events', '');
        }
      });
      scope.isCollapsible = scope.isCollapsible || false;
      scope.collapsibleIconUpName = scope.collapsibleIconUpName || 'spark-icon-chevron-up';
      scope.collapsibleIconDownName = scope.collapsibleIconDownName || 'spark-icon-chevron-down';
      scope.toggleChartVisibility = function () {
        scope.isVisible = !scope.isVisible;
      };
      $timeout(function () {
        var wrap = angular.element(element);
        var frame = wrap.find('.frame');
        var options = {
          horizontal: true,
          itemNav: 'centered',
          smart: 1,
          activateOn: 'click',
          mouseDragging: 1,
          touchDragging: 1,
          releaseSwing: 1,
          pagesBar: wrap.find('.pages'),
          activatePageOn: 'click',
          //startAt: 2,
          //scrollBar: wrap.find('.scrollbar'),
          //scrollBy: 1,
          //dragHandle: 1,
          //dynamicHandle: 1,
          //clickBar: 1,
          speed: 300,
          elasticBounds: 1,
          easing: 'swing',
          interactive: '.btn-group',
          // Buttons
          prevPage: wrap.find('.prev'),
          nextPage: wrap.find('.next')
        };
        var slyChange = _.throttle(function () {
          scope.$broadcast('perfect-scrollbar:update');
        }, 100);
        var sly = null;
        if (attrs.isWidthKnownOnPageLoad === 'true') {
          sly = new Sly(frame, options).init();
          sly.on('move', slyChange);
        }
        var reloadSly = function reloadSly(evt, activePage) {
          if (!sly) {
            sly = new Sly(frame, options).init();
            sly.on('move', slyChange);
          }
          sly.reload();
          if (!_.isUndefined(activePage)) {
            var pos = sly.getPos(activePage);
            sly.slideTo(pos.end, true);
          }
        };
        var delayedSly = _.debounce(reloadSly, 50);
        $window.addEventListener('resize', delayedSly);
        scope.$on('reload-carousel', delayedSly);
        scope.$on('destroy', function () {
          if (sly) {
            sly.off('move');
          }
          $window.removeEventListener('resize', delayedSly);
        });
      });
    }
  };
};
CarouselDirective.$inject = ['$window', '$timeout'];
module.exports = CarouselDirective;